module.exports = __webpack_public_path__ + "static/img/cut-e.4c0685a6.svg";